<template>
  <div
    :class="[$style.box]"
  >
    <ArticleChunk
      v-for="(item,index) in data.chunks "
      :key="index"
      :data="item"
    />
  </div>
</template>

<script>
import ArticleChunk from './ArticleChunk.vue'
export default {
  components: { ArticleChunk },
  props: { data: { type: Object, default: () => { return { chunks: [] } } } }
}
</script>

<style module>
.box{
  position: relative;
}

</style>
